<template>
  <div class="container">
    <h2 id="top-of-page">Cereal City Science Professional Learning - Available Sessions</h2>
    <p class="message" v-show="msg">** Registration submitted successfully! ** <br/>Registration confirmation will be sent to the email you entered. To register another participant, please make a selection below.</p>
    <p>Please select the training(s) you would like to register and click the "Register Selected" button at the bottom of the page. Deadline to register is one week prior to the scheduled workshop date. Visit our <a href="https://cerealcityscience.org/professional-learning" target="_blank">Main Website</a> for more detailed information about these and other training opportunities.<span style="color: #0e314d;"><b> All Cereal City Science Professional Learning programs qualify for State of Michigan SCECHs (State Continuing Education Clock Hours) free of charge.</b></span></p>
    
    <div class="training-wrapper">
      <div class="curric-filter">
        <h2>Sort by:</h2>
        <div class="grades">
          <div>
            <a @click.prevent="sortByGradeAsc">Grade Ascending</a>
          </div>
          <div>
            <a @click.prevent="sortByGradeDesc">Grade Descending</a>
          </div>
          <div>
          <a @click.prevent="sortByDateAsc">Date Ascending</a>
          </div>
          <div>
            <a @click.prevent="sortByDateDesc">Date Descending</a>
          </div>

        </div>
        <h2 style="border-top: 1px solid #cecece;">Filter by:</h2>
              <h4>Grade</h4>
              <div class="grades">
                <div v-for="grade in gradesList" :key="grade">
                  <input type="checkbox" :id="grade" :value="grade" v-model="grades">
                  <label :for="grade">{{ grade }}</label>
                </div>
              </div>

              <h4>Program</h4>
              <div class="programs">
                <div v-for="program in programsList" :key="program">
                  <input type="checkbox" :id="program" :value="program" v-model="programs">
                  <label :for="program">{{ program }}</label>
                </div>
              </div>
      </div>
      <div class="table-wrapper-wrapper">
        <div class="table-wrapper">
          <table style="width:100%" cellspacing="0" cellpadding="0">
            <thead>
              <tr class="tbl-hdr-bg">
                <th> </th>
                <th>GRADE
                  <a style="margin-left: 10px;" @click.prevent="sortByGradeAsc" v-if="sortBy === 'dateAsc' || sortBy === 'dateDesc'"><i class="fas fa-sort-down" style="color: #f9b278;"></i><i class="fas fa-sort-up" style="color: #f9b278; margin-left:-11px;"></i></a>
                  <a style="margin-left: 10px;" @click.prevent="sortByGradeDesc" v-if="sortBy === 'gradeAsc'"><i class="fas fa-sort-down" style="color: white;"></i><i class="fas fa-sort-up" style="color: #f9b278; margin-left:-11px;"></i></a>
                  <a style="margin-left: 10px;" @click.prevent="sortByGradeAsc" v-if="sortBy === 'gradeDesc'"><i class="fas fa-sort-down" style="color: #f9b278;"></i><i class="fas fa-sort-up" style="color: white; margin-left:-11px;"></i></a>
                </th>

                <th>PROGRAM</th>
                <th>SESSION TITLE</th>
                <th colspan="3">SESSION DATES/TIMES
                  <a style="margin-left: 10px;" @click.prevent="sortByDateAsc" v-if="sortBy === 'gradeAsc' || sortBy === 'gradeDesc'"><i class="fas fa-sort-down" style="color: #f9b278;"></i><i class="fas fa-sort-up" style="color: #f9b278; margin-left:-11px;"></i></a>
                  <a style="margin-left: 10px;" @click.prevent="sortByDateDesc" v-if="sortBy === 'dateAsc'"><i class="fas fa-sort-down" style="color: white;"></i><i class="fas fa-sort-up" style="color: #f9b278; margin-left:-11px;"></i></a>
                  <a style="margin-left: 10px;" @click.prevent="sortByDateAsc" v-if="sortBy === 'dateDesc'"><i class="fas fa-sort-down" style="color: #f9b278;"></i><i class="fas fa-sort-up" style="color: white; margin-left:-11px;"></i></a>
                </th>

                <th>LOCATION</th>
                <th>PRICE</th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr v-for="session in filteredSessions" :key="session.index">
                <!-- Checkbox -->
                <td><input type="checkbox" class="select-checkbox" v-model="selected" :value="{selectedTitle: session.title, selectedId: session.sessionId, selectedSessionOne: session.sessionOne, selectedSessionTwo: session.sessionTwo, selectedSessionThree: session.sessionThree, selectedTime: session.time, selectedProgram: session.program, selectedLocation: session.location, selectedSortDate: session.sortDate, selectedUnit: session.unit}"></td>
                <!-- Grade -->
                <td>{{ session.grade }}</td>
                <td>{{ session.program }}</td>
                <!-- Session Title -->
                <td class="unitColumn" v-if="session.location === 'BCAMSC' && session.program === 'Curriculum Training'">
                  <table style="width:100%; background-color: rgba(201, 76, 76, 0); padding: 0; margin: 0;" cellspacing="0" cellpadding="0">
                    <tr style="margin: 0; padding: 0;">
                      <td style="margin: 0; border: none;">{{session.title}}<br />
                        <!-- <span style="color: #7b8a1d;"><b>**Remember to register included {{ session.grade }} <i>Curriculum in Practice</i> session. Discount will be applied when invoiced.**</b></span> -->
                      </td>
                      <!-- <td style="margin: 0; border: none; color: #7b8a1d;"> -->

                        <!-- <select v-model="selected" :value="{selectedTitle: session.title, selectedId: session.sessionId, selectedSessionOne: session.sessionOne, selectedSessionTwo: session.sessionTwo, selectedSessionThree: session.sessionThree, selectedTime: session.time, selectedProgram: session.program, selectedLocation: session.location, selectedSortDate: session.sortDate, selectedUnit: session.unit}">
                          <option disabled value="">
                            Please select Curriculum in Practice session:
                          </option>
                          <option v-for="option in options" :value="option.value" :key="option.id"></option>
                        </select> -->
                      <!-- </td> -->
                    </tr>
                  </table>
                </td>

                <td class="unitColumn" v-if="session.location != 'BCAMSC' || session.program === 'Workshops'"><span>{{ session.title }} </span><span class="tooltip" v-if="session.description != ''"><i class="fas fa-info-circle" style="color: #525252;"></i><span class="tooltiptext" v-html="session.description"></span></span></td>


                <!-- Session Date - Only One Session -->
                <td colspan="3" v-if="session.sessionTwo === 'Invalid date'">{{ session.sessionOne }} - {{ session.time }}</td>
                <!-- Session Date - Two Sessions -->
                <td colspan="3" style="margin:0; padding: 0;" v-if="session.sessionTwo != 'Invalid date' && session.sessionThree === 'Invalid date'">
                  <table style="width:100%; background-color: rgba(201, 76, 76, 0); padding: 0; margin: 0;" cellspacing="0" cellpadding="0">
                    <tr style="margin: 0; padding: 0; display:grid; grid-template-columns: 1fr 1fr;">
                      <td  style="margin: 0; border: none; border-right: 1px solid #cecece;" v-if="session.sessionTwo != 'Invalid date'">{{ session.sessionOne }} <br /> {{ session.time }}</td>
                      <td  style="margin: 0; border: none;" v-if="session.sessionTwo != 'Invalid date' && session.sessionThree === 'Invalid date'">{{ session.sessionTwo }} <br /> {{ session.time }}</td>
                    </tr>
                  </table>
                </td>
                <!-- <td v-if="session.sessionTwo != 'Invalid date' && session.sessionThree === 'Invalid date'"> </td> -->
                <!-- <td v-if="session.sessionThree != 'Invalid date'">{{ session.sessionOne }} <br /> {{ session.time }}</td> -->
                <td v-if="session.sessionThree != 'Invalid date'">{{ session.sessionTwo }} <br /> {{ session.time }}</td>
                <td v-if="session.sessionThree != 'Invalid date'">{{ session.sessionThree }} <br /> {{ session.time }}</td>

                <!-- <td v-if="session.sessionTwo != 'Invalid date'">{{ session.sessionOne }}<br />{{ session.time }}</td>
                <td colspan="3" v-if="session.sessionTwo === 'Invalid date'">{{ session.sessionOne }}<br />{{ session.time }}</td>
                <td v-if="session.sessionTwo != 'Invalid date'">{{ session.sessionTwo }}<br />{{ session.time }}</td>
                <td v-if="session.sessionThree != 'Invalid date'">{{ session.sessionThree }}<br />{{ session.time }}</td> -->
                <td><span>{{ session.location }} </span><span class="tooltip" v-if="session.location === 'BCAMSC'"><i class="fas fa-info-circle" style="color: #525252;"></i><span class="tooltiptext">Battle Creek Area Mathematics and Science Center<br />171 West Michigan Avenue<br />Battle Creek, MI 49017<br /><a href="https://goo.gl/maps/xim2TPvQfrqPPJYSA" target="_blank" style="color: orange;">Map It!</a></span></span></td>
                <td><span v-if="session.cost != 'FREE'">$</span>{{ session.cost }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="selected-items">
          <h3 class="selected-header">Selected Trainings:</h3>
          <div class="selected-body">
            <ul>
              <li v-for="item in selected" :key="item.index">{{ item.selectedTitle }}</li>
            </ul>
            <button class="button" @click.prevent="registerSelected" :disabled="selected.length < 1">Register Selected</button>
            <button class="button secondary" @click.prevent="clearSelection">Clear All</button>
          </div>
        </div>
        <!-- <p style="font-size:.9em; margin-top: 0; margin-bottom: 50px;">* Price includes one Teacher Cohort session for selected grade level.</p> -->
      </div>
      <!-- <div v-if="grades.length > 0 || programs.length > 0" class="crumb-bar">
        <p>Displaying results for: <span class="filter-chip" v-for="grade in grades" :key="grade">{{ grade }}</span> <span class="filter-chip" v-for="program in programs"  :key="program">{{ program }}
          </span></p>
      </div> -->
      <!-- <p>Registering several participants? Use the <a href="/batch-registration">Batch Registration Form</a>.</p> -->

    </div>
    <div>
      <p class="fine-print"><b>Training/Workshop Cancellation Policy:</b> Cancellations must be made at least 7 days prior to the start of the workshop or training. If your district ordered a teacher guide for you, it will be shipped at the district's expense. If you do not cancel, you will be charged the predetermined rate for the workshop or training.</p>
    </div>
  </div>
</template>

<script>
const fb = require('./../firebase/firebase')
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      sessions: [],
      selected: [],
      sortBy: 'dateAsc',
      grades: [],
      gradesList: ['Kindergarten', '1st Grade', '2nd Grade', '3rd Grade', '4th Grade', '5th Grade', 'Middle School', 'High School'],
      programsList: ['Curriculum Training', 'Workshops', 'Webinars'],
      programs: []
    }
  },
  computed: {
    updatedGrades: function () {
      if (this.grades.length < 1) {
        return this.grades
      } else if (this.grades.includes('Middle School')) {
        var mshs = ['6th-12th Grade','3rd-8th Grade']
        var addmshs = this.grades.concat(mshs)
        return addmshs
      } else if (this.grades.includes('High School')) {
        var hs = ['6th-12th Grade']
        var addhs = this.grades.concat(hs)
        return addhs
      } else if (this.grades.includes('3rd Grade')) {
        var third = ['3rd-8th Grade','3rd-5th Grade']
        var addthird = this.grades.concat(third)
        return addthird
      } else if (this.grades.includes('4th Grade')) {
        var fourth = ['3rd-8th Grade','3rd-5th Grade']
        var addfourth = this.grades.concat(fourth)
        return addfourth
      } else if (this.grades.includes('5th Grade')) {
        var fifth = ['3rd-8th Grade','3rd-5th Grade']
        var addfifth = this.grades.concat(fifth)
        return addfifth
      } else {
        var any = ['All']
        var updated = this.grades.concat(any)
        return updated
      }
    },
    filteredSessions: function () {
      if (this.grades.length < 1 && this.programs.length < 1) {

        return this.sessions

      } else if (this.grades.length > 0 && this.programs.length < 1) {
        this.sortByGradeAsc()
        return this.sessions.filter(function (session) {
          return this.updatedGrades.includes(session.grade)
        }, this)

      } else if (this.grades.length < 1 && this.programs.length > 0) {
        return this.sessions.filter(function (session) {
          return this.programs.includes(session.program)
        }, this)

      } else {
        return this.sessions.filter(function (session) {
          // cd this.sortByGradeAsc()
          return this.updatedGrades.includes(session.grade) && this.programs.includes(session.program)
        }, this)
      }
    },
    ...mapState([ 'trainingsToRegister', 'msg' ])
  },
  methods: {
    fetchSequences() {
      fb.trainingSessionsCollection.where('active','==',true).orderBy('sessionOne', 'asc').orderBy('gradeSort', 'asc').get().then((snap) => {
        snap.forEach((doc) => {
          if (doc.data().sessionOne >= moment(new Date).add(1, 'day').format()) {
            this.sessions.push({
              sessionId:doc.id,
              active: doc.data().active,
              title: doc.data().title,
              sortDate: doc.data().sessionOne,
              sessionOne: moment(doc.data().sessionOne).format('LL'),
              sessionTwo: moment(doc.data().sessionTwo).format('LL'),
              sessionThree: moment(doc.data().sessionThree).format('LL'),
              time: doc.data().time,
              grade: doc.data().grade,
              gradeSort: doc.data().gradeSort,
              subject: doc.data().subject,
              program: doc.data().program,
              description: doc.data().description,
              location: doc.data().location,
              unit: doc.data().unit,
              cost: doc.data().cost,
              options: doc.data().options
            })
          }
        })
      }).then (() => {
        this.selected = this.trainingsToRegister
        if (this.$route.query.program != undefined) {
          this.programs.push(this.$route.query.program)
        }
        console.log(this.$route.query.test)
      })
    },
    clearSelection() {
      this.selected = []
      this.$store.commit('SET_TRAININGS_TO_REGISTER', [])
    },
    registerSelected() {
      // this.selected.forEach((element) => {
      //   this.$store.commit('SET_TRAININGS_TO_REGISTER', element.id)
      // })
      this.$store.commit('SET_TRAININGS_TO_REGISTER', this.selected)
      this.$router.push('/training-registration')
    },
    sortByGradeAsc() {
      console.log('Sorting by grade!')
      this.sessions.sort((a, b) => (a.gradeSort > b.gradeSort) ? 1 : (a.gradeSort === b.gradeSort) ? ((a.sortDate > b.sortDate) ? 1 : -1) : -1)
      this.sortBy = 'gradeAsc'
    },
    sortByGradeDesc() {
      console.log('Sorting by grade!')
      this.sessions.sort((a, b) => (a.gradeSort < b.gradeSort) ? 1 : (a.gradeSort === b.gradeSort) ? ((a.sortDate < b.sortDate) ? 1 : -1) : -1)
      this.sortBy = 'gradeDesc'
    },
    sortByDateAsc() {
      console.log('Sorting by date!')
      this.sessions.sort((a, b) => (a.sortDate > b.sortDate) ? 1 : (a.sortDate === b.sortDate) ? ((a.gradeSort > b.gradeSort) ? 1 : -1) : -1)
      this.sortBy = 'dateAsc'
    },
    sortByDateDesc() {
      console.log('Sorting by date!')
      this.sessions.sort((a, b) => (a.sortDate < b.sortDate) ? 1 : (a.sortDate === b.sortDate) ? ((a.gradeSort < b.gradeSort) ? 1 : -1) : -1)
      this.sortBy = 'dateDesc'
    }
  },
  created() {
    setTimeout(() => {
      this.$store.commit('SET_MSG', false)
    }, 180000)
  },
  mounted() {
    // if (this.userProfile.userRole === 'admin') {
    //   this.$router.push('/dashboard')
    // } else {
    // this.fetchSequences()
    // }
    this.fetchSequences()
  }
}
</script>

<style lang="css" scoped>
.training-wrapper {
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-gap: 20px;
}
.table-wrapper {
  margin-bottom: 20px;
  border: 2px solid #cecece;
  border-radius: 5px;
  overflow: visible;
}
table {
  border-collapse: collapse;
  background-color: white;
  font-size: .95em;
}
th,td {
  border: 1px solid #cecece;
  padding: 5px;
}
th {
  border-top: 0;
  font-weight: 700;
}
th:first-child {
  border-radius: 3px 0 0 0;
  border-left: 0;
}
th:last-child {
  border-right: 0;
  border-radius: 0 3px 0 0;
}
tbody>tr>:last-child {
  border-right: 0;
}
tbody>tr>:first-child {
  border-left: 0;
}
/* tbody>:last-child {
  background: pink;
  border-bottom: 0;
} */
.table-body>tr:last-child {
  /* background: green; */
  border-bottom: 0;
}

/* tr:last-child td:first-child {
   border-radius: 0 0 25px 0;
}
tr:last-child td:last-child {
   border-radius: 0 0 0 25px;
} */
.row-bg {
  background-color: lightgrey;
}
.tbl-hdr-bg {
  font-size: 1.2em;
  background-color: #f47e20;
  color: white;
}
tr:nth-child(even){
  background-color: #e6e6e6;
}
.unitColumn {
  text-align: left;
}
.selected-items {
  border: 2px solid #cecece;
  border-radius: 5px;
  text-align: left;

}
.selected-items .selected-header {
  border-bottom: 1px solid #cecece;
  border-radius: 3px 3px 0 0;
  background: #e6e6e6;
  padding: 10px 20px;
}
.selected-items .selected-body {
  padding: 0 20px 10px 20px;
}
input[type='checkbox']{
  width: 20px !important;
  height: 20px !important;
  margin: 5px;
  box-shadow: none;
  font-size: 2em;
}
h2 {
  margin-top: 20px;
}
.message {
  color: darkOrange;
  font-weight: 700;
  font-size: 1.2em;
}
/* Filter Styles */
.curric-filter {
  background: #fff;
  border: 1px solid #cecece;
  border-radius: 3px;
  overflow: hidden;
  text-align: left;
  height: fit-content;
  margin-bottom: 20px;
}
.curric-filter h2 {
  border-bottom: 1px solid #cecece;
  padding: 15px;
  background: #f7f7f7;
  margin: 0;
}
.curric-filter h4 {
  margin: 15px;
  border-bottom: 1px solid #000812;
}
.grades, .programs {
  margin: 15px;
}
/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  /* If you want dots under the hoverable text */
  /* border-bottom: 1px dotted black; */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #0e314d;
  color: #fff;
  text-align: center;
  padding: 5px 20px;
  border-radius: 6px;
  text-align: left;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
.tooltip .tooltiptext {
  top: -50px;
  right: 105%;
}
.tooltip .tooltiptext::after {
  content: " ";
  position: absolute;
  top: 50%;
  left: 100%; /* To the right of the tooltip */
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent black;
}
.tooltip .tooltiptext {
  opacity: 0;
  transition: opacity 1s;
}

.tooltip:hover .tooltiptext {
  opacity: 1;
}
.fine-print {
  font-size: .7em;
}
</style>
